import { render, staticRenderFns } from "./_details.vue?vue&type=template&id=17bb75fe&"
import script from "./_details.vue?vue&type=script&lang=js&"
export * from "./_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports